import { EmployeeOutreachComponent } from "@/features"

export const EmployeeOutreachPage = () => {
  return <EmployeeOutreachComponent />
}
